import {
    AuthUser,
    Problem,
    ProblemMinimalWithAuthorAndCreated,
    ProblemMinimalWithFlagStatsAndRating,
    SingleProblem,
} from '@types';

export const canEditProblem = (
    user: AuthUser | null | undefined,
    problem:
        | Problem
        | ProblemMinimalWithAuthorAndCreated
        | ProblemMinimalWithFlagStatsAndRating
        | SingleProblem
        | null
        | undefined
): boolean => {
    if (!problem) return false;

    const isEditor = user?.isEditor;
    const isAdmin = user?.isAdmin;
    const isAuthor = user?.id === problem.author.id;

    return Boolean(isEditor || isAdmin || isAuthor);
};
